import rectangle55 from '../../assets/images/Rectangle-55.png';
import rectangle56 from '../../assets/images/Rectangle-56.png';
import rectangle57 from '../../assets/images/Rectangle-57.png';

const data = [
  {
    id: 1,
    title: 'Front-End Development',
    src: rectangle55,
    alt: 'Rectangle design',
    skills: ['HTML, CSS & SASS', 'JavaScript', 'TypeScript', 'Tailwind', 'ReactJs'],
  },
  {
    id: 2,
    title: 'Back-End Development',
    src: rectangle56,
    alt: 'Rectangle design',
    skills: ['Ruby on rails', 'MongoDb', 'Express', 'NodeJs', 'MySQL', 'Ruby'],
  },
  {
    id: 3,
    title: 'Tools',
    src: rectangle57,
    alt: 'Rectangle design',
    skills: ['Responsive Web Design', 'Git & GitHub', 'Webpack', 'SEO', 'TDD'],
  },
  {
    id: 4,
    title: 'Professional Skills',
    src: rectangle55,
    alt: 'Rectangle design',
    skills: ['Advanced Technical Writing', 'Advanced Technical Writing', 'Project management', 'Documentation', 'Mentorship', 'Leadership'],
  },
];

export default data;
